define(
  [
    'store',
    'jquery',
    'underscore',
    'backboneRadix',
    'darsan',
    'darsanCacheRadix',
    'common',
    'sysconf',
    'preload',
    'radio',

    'permission',

    'common/visual/visual',
    'location-input',

    'text-loader!client/edit/info.tpl'
  ],
  function(
    store,
    $,
    _,
    Backbone,
    darsan,
    darsanCache,
    common,
    sysconf,
    preload,
    radio,
    perm,
    Visual,
    locInput,
    template
  ) {
    'use strict';
    return Object.create(Visual).extend({
      title: 'Данные',
      name: 'clientInfo',
      icon: 'user',

      create: function(el, opt) {
        var me = this;
        Visual.create.apply(me, arguments);

        var pppoeView = Backbone.TemplateCooperView.extend({
          events: {
            'click .show-password': 'togglePassword',
            'click .generate-password': '_generatePassword',
            'click .save-password': '_savePassword',
            'click .cancel-password': '_cancelPassword',
            'change [name=status]': 'colorDisableSelect'
          },

          template: template,

          togglePassword: function() {
            var input = this.$('[name=password]');
            var icon = this.$('span.show-password');

            if (input.attr('type') === 'password') {

		        if( _.isEmpty(input.attr('value'))){
		          var me     = this.module;
		          var prefix = sysconf.domainByUid(me.state.uid) || config.domain;
		          darsan.get(prefix, "client", "/client/"+me.state.uid+"/password").then(rec =>{
                input.attr('value', rec.password).removeAttr('disabled');
		          }, e => {
		            let data;
			    try{
    				data = JSON.parse(e.responseText)||{};
			    } catch {
		    		data = { text: e.statusText + " " + e.status, name: e.status };
			    };
		        common.notifyError('"' + data.name + '" ' + (data.text_ru || data.text));
			    });
		        }

            input.attr('type', 'text');
	          icon.addClass('glyphicon-eye-close').removeClass('glyphicon-eye-open');
            } else {
              input.attr('type', 'password');
              icon.addClass('glyphicon-eye-open').removeClass('glyphicon-eye-close');
            }
          },

          _generatePassword: function() {
            var input = this.$('[name=password]');
            var password = Math.random().toString(36).slice(-8);

            var data_old = input.attr('data-old-val');
            if (!data_old) {
              input.attr('data-old-val', input.val());
            }

            input.val(password);
            this.$('.save-password').removeClass("hidden")
            this.$('.cancel-password').removeClass("hidden")
          },
          
          _cancelPassword()
          {
            const input = this.$('[name=password]')
            input.val(input.attr('data-old-val'))
            this.$('.save-password').addClass("hidden")
            this.$('.cancel-password').addClass("hidden")
          },

          _savePassword: function() {
            var input = this.$('input[name=password]');
            input.trigger('cooper:changed');
            this.$('.save-password').addClass("hidden")
            this.$('.cancel-password').addClass("hidden")
          },

          extraRender: function() {
            var me = this;

            var prefix = sysconf.domainByUid(this.model.get('uid')) || config.domain;

            locInput.create(null, null, this.$('[name=full_location]'), null, this.model, prefix);

      	    me.colorDisableSelect();

          },
          colorDisableSelect: function() {
            var select = this.$('[name=status]');

            if (select.val() > 0) {
              return select.css('background', '#ebcccc');
            }

            return select.css('background', 'white');
          }
        });

        me.attr = {doc_type: store.store.getters.attr("client", "client", "doc_type")}
        
        const infoModel = Backbone.ModelEx.extend({
          idAttribute: "entity"
        })
        
        me.view = new pppoeView({
          el: me.$el,
          module: me,
          model: new infoModel(),
        });
        
        return preload.ensure('group', 'fop', 'legal-types', 'worker');
      },
      
      setState(state)
      {
        this.state = state
        var me = this;

        const uid = state.id
        me.prefix = sysconf.domainByUid(uid) || config.domain;

        me.workers = preload.get(me.prefix, 'worker');
        me.groups = preload.get(me.prefix, 'group');
        me.fops = preload.get(me.prefix, 'fop');
        me.legalTypes = preload.get(me.prefix, 'legal-types');

        me.groupResponsibles = {};
        _.each(me.workers.models, (worker) => {
          me.groupResponsibles[worker.get('entity')] = worker.get('surname') + ' ' + worker.get('name');
        });

        radio.channel("owners").request("model:client:info:promise")
        .then((model) =>
        {
            me.view.model = model
            me.view.render()
        })
      },
      
    });
  }
);
